var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.268,
    height: 510.279,
    viewBox: "0 0 183.268 510.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10856",
    "data-name": "Group 10856",
    transform: "translate(-8463.433 -1270.975)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44796",
    "data-name": "Path 44796",
    d: "M182.263,228.073A91.229,91.229,0,0,1,85.2,319.015C39.649,316.114,2.9,279.357.172,233.8a90.418,90.418,0,0,1,28.556-72.1l7.4-6.958a2.033,2.033,0,0,1,3.264,2.273l-3.948,9.353a61.731,61.731,0,0,0-3,38.389,57.953,57.953,0,0,0,36.328,41.475c42.638,15.521,82.79-15.829,82.79-56.379a60.043,60.043,0,0,0-4.734-23.485l-3.95-9.353a2.034,2.034,0,0,1,3.267-2.273l7.4,6.958a90.26,90.26,0,0,1,28.728,66.38m-8.358,0a82.1,82.1,0,0,0-10.18-39.863,2.039,2.039,0,0,0-3.814,1.047c0,.188,0,.373,0,.56.016,35.087-26.875,65-61.79,68.464a68.859,68.859,0,0,1-75.776-68.435c0-.205,0-.413,0-.618a2.033,2.033,0,0,0-3.8-1.047A81.957,81.957,0,0,0,8.391,225.619c-1.277,44.632,33.754,82.794,78.344,85.114a82.863,82.863,0,0,0,87.17-82.66",
    transform: "translate(8463.938 1461.545)",
    fill: "#0c9",
    stroke: "#0c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44797",
    "data-name": "Path 44797",
    d: "M165.385,138.654a4.307,4.307,0,0,0,0-4.309L89.064,2.154a4.308,4.308,0,0,0-7.462,0L5.281,134.345a4.309,4.309,0,0,0,3.731,6.464H161.654a4.305,4.305,0,0,0,3.731-2.155M85.333,12.925,154.192,132.19H16.474Z",
    transform: "translate(8469.738 1271.476)",
    fill: "#0c9",
    stroke: "#0c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44798",
    "data-name": "Path 44798",
    d: "M89.064,216.6,165.387,84.4a4.308,4.308,0,0,0-3.731-6.462H9.012A4.308,4.308,0,0,0,5.281,84.4L81.6,216.6a4.308,4.308,0,0,0,7.462,0m65.13-130.037L85.333,205.824,16.474,86.559Z",
    transform: "translate(8469.735 1367.568)",
    fill: "#0c9",
    stroke: "#0c9",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up_down_arrow.f6d5a4ebd99c1dd0399adf49f7f917b6.svg";
export { ForwardRef as ReactComponent };